import React from 'react';
import Tooltip from './Tooltip';
import styles from './Form.module.css';

interface FormProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  isLoading?: boolean;
  onSubmit: (e: React.FormEvent) => void;
  submitButtonText?: string;
  children: React.ReactNode;
}

const Form: React.FC<FormProps> = ({
  title,
  description,
  icon,
  isLoading = false,
  onSubmit,
  submitButtonText = 'Submit',
  children
}) => {
  return (
    <div className={styles.formContainer}>
      <div className={styles.formHeader}>
        {icon && (
          <div className={styles.formIcon}>
            {icon}
          </div>
        )}
        <h3 className={styles.formTitle}>{title}</h3>
      </div>
      
      <p className={styles.formDescription}>{description}</p>
      
      <form className={styles.form} onSubmit={onSubmit}>
        {children}
        
        <Tooltip content={isLoading ? "Processing..." : submitButtonText}>
          <button
            type="submit"
            className={styles.submitButton}
            disabled={isLoading}
            aria-label={submitButtonText}
          >
            {isLoading ? (
              <span className={styles.loadingSpinner}></span>
            ) : (
              submitButtonText
            )}
          </button>
        </Tooltip>
      </form>
    </div>
  );
};

export default Form;